import { Component, OnInit, Inject } from '@angular/core';
import { UserService } from 'src/app/_service/user.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IdentityUser } from 'src/app/_models/identityUser';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { User } from 'src/app/_models/user';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/_service/auth.service';
import { LoginComponent } from 'src/app/login/login.component';

@Component({
  selector: 'user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

  model: any = {};
  hide = true;
  userProfileForm: FormGroup;
  restrictedAccess: any = [];
  emailAddressChanged: any = [];

  constructor(private userService: UserService,
    private alertify: AlertifyService,
    private router: Router,
    private route: ActivatedRoute,
    public fb: FormBuilder,
    public dialog: MatDialog,
    public authService: AuthService,

    @Inject(MAT_DIALOG_DATA) public passedData: any) {

      this.userProfileForm = fb.group({
        firstNameFormControl : new FormControl('', [
          Validators.required,
          Validators.maxLength(50),
          this.WhitespaceValidator
        ]),
        lastNameFormControl : new FormControl('', [
          Validators.required,
          Validators.maxLength(70),
          this.WhitespaceValidator
        ]),
        postalCodeFormControl : new FormControl('', [
          // Validators.required,
          // Validators.maxLength(7),
          // this.WhitespaceValidator
        ]).clearValidators(),
        addressLine1FormControl : new FormControl('', [
          // Validators.required,
          // Validators.maxLength(125),
          // this.WhitespaceValidator
        ]).clearValidators(),
        addressLine2FormControl : new FormControl('', [
          // Validators.required,
          // Validators.maxLength(125),
          // this.WhitespaceValidator
        ]).clearValidators(),
        countryFormControl : new FormControl('', [
          // Validators.required,
          // Validators.maxLength(50),
          // this.WhitespaceValidator
        ]).clearValidators(),
        cityFormControl : new FormControl('', [
          // Validators.required,
          // Validators.maxLength(50),
          // this.WhitespaceValidator
        ]).clearValidators(),
        provinceFormControl : new FormControl('', [
          // Validators.required,
          // Validators.maxLength(50),
          // this.WhitespaceValidator
        ]).clearValidators(),
        faxNumberFormControl : new FormControl('', [
          // Validators.required,
          // Validators.maxLength(20),
          // this.WhitespaceValidator,
          // Validators.pattern('\d{0,20}')
        ]).clearValidators(),
        phoneNumberFormControl : new FormControl('', [
          // Validators.required,
          // Validators.maxLength(20),
          // this.WhitespaceValidator,
          // Validators.pattern('\d{0,20}')
        ]).clearValidators(),
        emailFormControl: new FormControl('', [
          Validators.required,
          // Validators.email,
          this.WhitespaceValidator,
          Validators.pattern('^[a-zA-Z0-9_.+-]+[@]{1}[a-zA-Z0-9-.]+[.]{1}[a-zA-Z0-9]{2,3}$'),
        ])
      });
    }

    confirmPassword;
    password;

    userOutsideId = this.passedData.user;

    user = {
      userOutsideId: '',
      password: ''
    };
    sdsUser = {
      emailAddress: '',
        firstName: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        country: '',
        city: '',
        province: '',
        faxNumber: '',
        phoneNumber: '',
        postalCode: '',
        userOutsideId: ''
    };

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  ngOnInit() {
    this.loadSDSUser();
  }


  loadSDSUser() {
    this.userService.getUser(this.userOutsideId).subscribe((user: User) => {
      this.sdsUser = user;
    },
    error => {
      this.alertify.error(error);
    });
  }

  loginPrompt() {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '500px'
    });
  }

  UpdatePassword() {
      if (this.password === this.confirmPassword) {
        this.user.userOutsideId = this.userOutsideId;
        this.user.password = this.password;

        return this.userService.updateIdentityPassword(this.user).subscribe(next => {

          this.alertify.success('Your password has been changed');
          
        }, error => {
          this.alertify.error(error);
        });
      } else {
        this.alertify.error('Passwords do not match');
      }
  }

  updateSDSUser() {
    this.sdsUser.emailAddress = this.userProfileForm.get('emailFormControl').value;
    this.userService.updateUserInfo(this.userOutsideId, this.sdsUser).subscribe(
      res => {
      this.restrictedAccess = res.headers.get('restrictedaccess');
      if (this.restrictedAccess) {
        this.alertify.message(this.restrictedAccess);
      }
      this.emailAddressChanged = res.headers.get('emailchanged');
      if (this.emailAddressChanged) {
        this.alertify.message(this.emailAddressChanged);
        this.dialog.closeAll();
        this.authService.logout();
        this.loginPrompt();
      } else {
        this.alertify.success('Profile updated successfully');
        this.dialog.closeAll();
      }
    }, error => {
      this.alertify.error('Something went wrong. Please try again later.');
    }
    );

  }

}
